import React, { useEffect, useMemo, useState, createContext } from "react";
import axios from "axios";
import { IdMap } from "shared-types";
import { getMeasures, Measure } from "utils/api";
import { convertToIdMap } from "utils/misc";

export const MeasuresContext = createContext<[IdMap<Measure> | null, string | null]>([null, null]);

export const MeasuresProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [fetchedMeasures, setFetchedMeasures] = useState<Array<Measure> | null>(null);
  const [error, setError] = useState<string | null>(null);
  const signal = new AbortController().signal;
  useEffect(() => {
    const fetchMeasures = async () => {
      try {
        const response = await getMeasures(signal);
        setFetchedMeasures(response);
      } catch (err: unknown) {
        if (axios.isCancel(err)) {
          console.log("Request canceled intentionally");
          return; // Do nothing
        }
        //@ts-expect-error missing type
        setError(err.toString());
        console.log("Error fetching measures:", err);
      }
    };
    fetchMeasures();
  }, []);

  const measures = useMemo(() => fetchedMeasures && convertToIdMap(fetchedMeasures), [fetchedMeasures]);

  return <MeasuresContext.Provider value={[measures, error]}>{children}</MeasuresContext.Provider>;
};
